import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as hazardCategoriesServiceClear } from './hazardCategoriesService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'hazardCategories',
  serviceTableName: 'hazardCategoriesService',
  serviceClearFunction: hazardCategoriesServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.hazardCategory]),
});
